import { render, staticRenderFns } from "./ProformaInvoiceDetail.vue?vue&type=template&id=e188d124&scoped=true"
import script from "./ProformaInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./ProformaInvoiceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e188d124",
  null
  
)

export default component.exports